import CreatePasswordModal from './CreatePasswordModal';

export default CreatePasswordModal;